import { Module } from 'vuex';
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import CategoriesState from '../types/CategoriesTypes'

export const module: Module<CategoriesState, any> = {
  namespaced: true,
  state: {
    categories: [],
    categoriesLoad: false,
    categories_loaded: 2,
    categoriesProducts: [],
    rawCategories: []
  },
  actions,
  getters,
  mutations
}
